import React, { useState } from 'react';
import cx from 'classnames';

import { PlayersMarketRowDesktop } from './players-market-row-desktop';
import { PlayersMarketRowMobile } from './players-market-row-mobile';
import trans from '../../../../../common/utils/trans';
import { urls } from '../../../../../configs';
import { DeleteFavoriteItemModal } from '../../../components/my-favorites/delete-fav-tournament-modal';

const PlayersMarket = ({
    match,
    items,
    market,
    viewSize,
    userCanCashout,
    viewOrder,
    withHeader = true,
    activeMarketGroup,
    userIsLogged,
    favorites,
    favLoading,
    isFavorite,
    modal,
}) => {
    const [isOpened, setOpened] = useState(!(viewOrder > 10));
    const [currentCompetitorId, setCurrentCompetitorId] = useState(null);

    const homeLogo = urls.prematchCompetitorImg + match?.competitor1.id + '.png';
    const awayLogo = urls.prematchCompetitorImg + match?.competitor2.id + '.png';

    const isPlayerInTeam = (item) => {
        return (
            item &&
            (!currentCompetitorId ||
                !!match.players[currentCompetitorId].find((player) => player.name === item.replacedPlayerSpecifier))
        );
    };
    const CashoutIcon = ({ market }) =>
        userCanCashout ? (
            <i
                className={`doruk-cashout-01${
                    market.canCashout ? ' market__icon--can-cashout' : ' market__icon--cant-cashout'
                }`}
                title={trans(market.canCashout ? 'Cashout possible' : 'Cashout not possible')}
            />
        ) : (
            <span className="market__icon--can-cashout" />
        );

    return (
        <div
            className={cx(
                'match-details__market',
                'match-player-market',
                viewSize && `match-player-market--${viewSize}`,
                activeMarketGroup === -1 && 'match-player-market--all'
            )}
            data-market-id={market.id}
            key={market.id}
        >
            {withHeader && (
                <div className="match-details__market-header" onClick={() => setOpened((v) => !v)}>
                    <span className="match-details__market-header-clickers">
                        {userIsLogged ? (
                            <span
                                className="match-details__market-header-fav-icon-wrp"
                                onClick={(e) => {
                                    e.stopPropagation();
                                    if (!favLoading) {
                                        if (isFavorite && favorites.isMarketFavorite({ id: market.id })) {
                                            modal.setModal({
                                                active: true,
                                                maskBackground: true,
                                                showHeader: true,
                                                title: trans('Favorite markets'),
                                                showCloseButton: true,
                                                currentKey: 'custom-content',
                                                customClasses: 'delete-favorite-modal',
                                                customContent: (
                                                    <DeleteFavoriteItemModal
                                                        deleteItem={(e) => {
                                                            e.preventDefault();
                                                            favorites.setFavoriteMarket({
                                                                id: market.id,
                                                                isFavorite: true,
                                                            });
                                                            modal.close();
                                                        }}
                                                        type="market"
                                                    />
                                                ),
                                            });
                                        } else {
                                            favorites.setFavoriteMarket({
                                                id: market.id,
                                            });
                                        }
                                    }
                                }}
                            >
                                <i
                                    className={`match-details__market-header-fav-icon doruk-star-${
                                        favorites.isMarketFavorite({ id: +market.id }) ? 'fill' : 'line'
                                    }`}
                                ></i>
                            </span>
                        ) : null}
                        <span className="match-details__view-switcher-box" />
                    </span>
                    <div className="match-details__market-header-name">
                        <div
                            dangerouslySetInnerHTML={{ __html: market.shortName || market.shortedName || market.name }}
                        />
                    </div>
                    <span className="match-details__market-expand">
                        <CashoutIcon market={market} />
                        <i
                            className={cx(
                                'match-details__market-expand-icon llg-chevron-right',
                                isOpened && 'match-details__market-expand-icon--expanded'
                            )}
                        />
                    </span>
                </div>
            )}

            <div className={cx('match-details__content', isOpened && 'match-details__content--opened')}>
                <div className="competitor-filter">
                    <div
                        className={cx('competitor-filter__item', currentCompetitorId === null && 'active')}
                        onClick={() => {
                            setCurrentCompetitorId(null);
                        }}
                    >
                        {trans('All')}
                    </div>
                    <div
                        className={cx(
                            'competitor-filter__item',
                            currentCompetitorId === match.competitor1.id && 'active'
                        )}
                        onClick={() => {
                            setCurrentCompetitorId(match.competitor1.id);
                        }}
                    >
                        {viewSize !== 'mobile' && !match.homeTeamHasLogo && match.competitor1.name}
                        {match.homeTeamHasLogo ? (
                            <img className="competitor-filter__item-img" src={`${homeLogo}`} alt="" />
                        ) : null}
                    </div>
                    <div
                        className={cx(
                            'competitor-filter__item',
                            currentCompetitorId === match.competitor2.id && 'active'
                        )}
                        onClick={() => {
                            setCurrentCompetitorId(match.competitor2.id);
                        }}
                    >
                        {viewSize !== 'mobile' && !match.awayTeamHasLogo && match.competitor2.name}
                        {match.awayTeamHasLogo ? (
                            <img className="competitor-filter__item-img" src={`${awayLogo}`} alt="" />
                        ) : null}
                    </div>
                </div>
                <div className="match-player-market__content">
                    <div className="match-player-market__headers-wrp">
                        {items.map((item, i) =>
                            isPlayerInTeam(item) ? (
                                <div className="match-player-market__header" key={item.replacedPlayerSpecifier}>
                                    <span>{item.replacedPlayerSpecifier}</span>
                                </div>
                            ) : null
                        )}
                    </div>
                    <div className="match-player-market__bets-wrp">
                        {items.map((item, i) =>
                            isPlayerInTeam(item) ? (
                                viewSize === 'desktop' ? (
                                    <PlayersMarketRowDesktop item={item} key={item.replacedPlayerSpecifier} />
                                ) : (
                                    <PlayersMarketRowMobile item={item} key={item.replacedPlayerSpecifier} />
                                )
                            ) : null
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default PlayersMarket;
